export default __webpack_public_path__ + "static/media/STRIPAnimatGif-ForceWhite.66f300f0.gif";